// React & Core
import Cookies from "js-cookie";
import { useEffect } from "react";

// Global State
import { useAppSelector } from "redux/reducers/hooks";

// Material UI
import { Box, useTheme } from "@mui/material";

// Custom Hooks
import useDisclosure from "components/hooks/useDisclosure";

// Dialog Components
import DetailDialogTitle from "components/common/Materialui/DetailDialog/DetailDialogTitle";
import DialogBase from "components/common/Materialui/DetailDialog/DialogBase";

function DownloadAppPopup() {
  // Hooks & State
  const [modalOpen, modalHandlers] = useDisclosure();
  const user = useAppSelector((state) => state.rootAuth.user);

  // Theme & Layout
  const theme = useTheme();
  const isRTL = theme.direction === "rtl";

  async function checkAppSessionToken() {
    const appPopup = Cookies.get("download_app_popup_viewed") === "true";
    if (!appPopup) {
      modalHandlers.open();
      Cookies.set("download_app_popup_viewed", "true", { expires: 2 });
    }
  }

  useEffect(() => {
    checkAppSessionToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!modalOpen && user?.is_loyac_staff) return <></>;
  return (
    <DialogBase
      contentProps={{
        sx: {
          padding: "24px",
        },
      }}
      sx={{
        "& .MuiSvgIcon-root": {
          width: "32px",
          height: "32px",
          padding: "4px",
        },
      }}
      PaperProps={{
        style: {
          width: "53vw",
          maxWidth: "800px",
          minWidth: "350px",
        },
      }}
      open={modalOpen}
      onClose={modalHandlers.close}
      hideDialog={modalHandlers.close}
      title={<DetailDialogTitle onClose={modalHandlers.close} />}
      content={
        <Box
          sx={{
            width: "100%",
            position: "relative", // make container relative for absolute positioning
          }}
        >
          <img
            src={
              isRTL
                ? "/images/banners/download_app_ar.webp"
                : "/images/banners/download_app_en.webp"
            }
            alt="Download LOYAC app"
            style={{
              objectFit: "contain",
              maxWidth: "100%", // instead of width: 100%
              display: "block",
              margin: "0 auto", // center horizontally
            }}
          />

          {/* Overlay buttons at bottom center */}
          <Box
            display="flex"
            gap={2}
            justifyContent="center"
            sx={{
              position: "absolute",
              bottom: "10%", // distance from bottom of image
              left: "50%",
              transform: "translateX(-50%)", // center horizontally
            }}
          >
            <a
              href="https://apps.apple.com/us/app/loyac/id6745540593"
              target="_blank"
              rel="noreferrer"
            >
              <img
                style={{
                  objectFit: "contain",
                  width: "12vw",
                  minWidth: "70px",
                }}
                src="/icons/ios_download_app.webp"
                alt="Download LOYAC App on App Store"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=org.loyac.apply&hl=en"
              target="_blank"
              rel="noreferrer"
            >
              <img
                style={{
                  objectFit: "contain",
                  width: "12vw",
                  minWidth: "70px",
                }}
                src="/icons/google_play_download_app.webp"
                alt="Download LOYAC App on Google Play Store"
              />
            </a>
          </Box>
        </Box>
      }
      actions={undefined}
      subheader={undefined}
      TransitionComponent={undefined}
      disableDefaultClose={undefined}
    />
  );
}

export default DownloadAppPopup;
